export default {
  en: {
    general: 'General',
    agent: 'Agent',
    promotion: 'Promotion'
  },
  th: {
    general: 'ทั่วไป',
    agent: 'ตัวแทน',
    promotion: 'โปรโมชั่น'
  }
}
